import { r as registerInstance, h, H as Host } from './index-1755b6c5.js';

const CreateServiceCaseModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.handleModalClose = () => {
            window.location.reload();
        };
        this.fileUpload = false;
        this.prefillData = null;
        this.modalName = undefined;
        this.locale = "en-US";
        this.env = "prod";
        this.legacyApi = false;
    }
    handleServiceCaseSuccess() {
        this.modal.triggerClose();
    }
    handleServiceCaseCancel() {
        this.modal.triggerClose();
    }
    render() {
        return (h(Host, { key: 'bc048686061a1e853c33344cc523c5558990382d' }, h("ux-modal", { key: '94c6ba519cc66b010e50eca7480328be65d3a049', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: 'b94befe690179cc274bb7d4e9cc4cdbca4962061' }, h("mf-create-service-case", { key: '4077767e163f89c641e31e2b59b391d940d54e3a', fileUpload: this.fileUpload, prefillData: this.prefillData, multipleSteps: true, locale: this.locale, env: this.env, legacyApi: this.legacyApi }, h("slot", { key: 'b1d49d3abfa134534a3755b3e78d7f05c3dd4e4b', name: "connector" }))))));
    }
};

export { CreateServiceCaseModal as mf_create_service_case_modal };

//# sourceMappingURL=mf-create-service-case-modal.entry.js.map